// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"16d7234d","208":"c1fd26d4","691":"d29452f2"}[chunkId] + ".chunk.css";
};